export default __webpack_public_path__ + "static/media/website.f7fb1528.jpg";